import React from 'react';
import { APIURL } from '../../../config/config'
import axios from 'axios'
import { NumberUtil } from '../../../utils/number-util'

class CarLeasingForm2 extends React.Component{
	constructor (props) {
		super(props)
		this.state = {
			car_id : this.props.car.car_id,
			lists: [],
			leasingName: [],
			action: 'add',
			leasingPercents: [
				{percent_id: 1, percent_name: '95%', percent_value: 95},
				{percent_id: 2, percent_name: '90%', percent_value: 90},
				{percent_id: 3, percent_name: '85%', percent_value: 85},
				{percent_id: 4, percent_name: '80%', percent_value: 80},
				{percent_id: 5, percent_name: '75%', percent_value: 75},
			]
		}
		this.loadCarLeasingForm = this.loadCarLeasingForm.bind(this);
		this.loadCarLeasing = this.loadCarLeasing.bind(this);
		this.handlePriceMedianInput = this.handlePriceMedianInput.bind(this);
		this.handlePercentInput = this.handlePercentInput.bind(this);
	}

	componentDidMount() {
		this.loadCarLeasingForm();
		this.loadCarLeasing();
	}

	loadCarLeasingForm() {
		var url = APIURL + '/leasing_setting/';
		axios.get(url)
		.then(res => {
			// car_leasing_price  ยอดจัด
			// car_leasing_percent  เปอร์เซ็นต์
			// car_leasing_price_median ราคากลาง
			const leasingName = res.data
			const leasingNames = leasingName.map(leasing => {
				return {...leasing, ...{
						car_leasing_price_median: '',
					  car_leasing_percent: 90,
						car_leasing_price: ''
				}}
			})
			this.setState({leasingName: leasingNames})
		});
	}

	loadCarLeasing() {
		var uri =  APIURL + '/car_leasing/'+this.state.car_id;
		axios.get(uri).then(res => {
			const list = res.data
			if(list.length > 0){
				this.setState({lists: res.data, action: 'add'})
			}
		})
	}

	handlePriceMedianInput(event, leasingIndex) {
		const {leasingName} = this.state;
		// var targetName = event.target.name;
		var targetValue = event.target.value;
		const leasing = leasingName[leasingIndex];
		leasing.car_leasing_price_median = targetValue

		if(targetValue > 0) {
			leasing.car_leasing_price = targetValue * (leasing.car_leasing_percent/100)
		} else {
			leasing.car_leasing_price = ''
		}

		leasingName[leasingIndex] = leasing

		this.setState({
			leasingName: leasingName
		})
	}

	handlePriceMedianInputUpdate(event, leasingIndex) {
		const leasingLists = this.state.lists
		var targetValue = event.target.value;
		// var targetName = event.target.name;

		const leasing = leasingLists[leasingIndex];
		leasing.car_leasing_price_median = targetValue

		leasingLists[leasingIndex] = leasing

		this.setState({
			lists: leasingLists
		})

	}

	handlePercentInput(event, leasingIndex) {
		const {leasingName} = this.state;
		// var targetName = event.target.name;
		var targetValue = event.target.value;

		const leasing = leasingName[leasingIndex];
		const car_leasing_price_median = leasing.car_leasing_price_median
		leasing.car_leasing_percent = targetValue
		leasing.car_leasing_price = (car_leasing_price_median) * (targetValue/100)

		leasingName[leasingIndex] = leasing

		this.setState({
			leasingName: leasingName
		})
	}

	render() {
		var trLeasing = ''
		const leasingPercents = this.state.leasingPercents


		if(this.state.lists.length === 0){ // เพิ่มใหม่
			trLeasing = this.state.leasingName.map((leasing, index) => {
				var nameMedian = leasing.name_median;
				var leasingPriceMedian = leasing.car_leasing_price_median;
				var leasingPricePercent = leasing.car_leasing_percent;
				var leasingPrice = leasing.car_leasing_price;
				var inputM = '';

// car_leasing_price
				inputM = (
					<input
						className="form-control"
						type="number"
						id={leasing.name_median}
						name={leasing.name_median}
						onChange={(event) => this.handlePriceMedianInput(event, index)}
						value={leasingPriceMedian}
					/>
				)

				let leasingPercentSelect = (
					<select className="form-control"
					        name={'leasingPercent_'+nameMedian}
					        onChange={(event) => this.handlePercentInput(event, index)}
					        value={leasingPricePercent}
					>
						{leasingPercents.map(leasingPercent => {
							if(leasingPercent.percent_value === leasingPricePercent){
								return (
									<option key={leasingPercent.percent_id}
									        value={leasingPercent.percent_value}
									        selected="selected"
									>
										{leasingPercent.percent_name}
									</option>
								)
							}else{
								return (
									<option key={leasingPercent.percent_id}
									        value={leasingPercent.percent_value}
									>
										{leasingPercent.percent_name}
									</option>
								)
							}

						})}
					</select>
				)

				return (
					<tr key={index}>
						<td style={{width: 100}}>{leasing.name_credit}</td>
						<td style={{width: 150}}>{inputM}</td>
						<td style={{width: 150}}>{leasingPercentSelect}</td>
						<td style={{width: 150}}>{leasingPrice>0? NumberUtil.addCommas(leasingPrice) : '-'}</td>
					</tr>
				)
			})
		} else {
			const leasingLists = this.state.lists

			trLeasing =	leasingLists.map((leasing, index) => {
				var nameMedian = leasing.car_leasing_name;
				var leasingPriceMedian = leasing.car_leasing_price_median;
				// var leasingPricePercent = leasing.car_leasing_percent;
				// var leasingPrice = leasing.car_leasing_price;

				var inputM = '';

				inputM = (
					<input
						className="form-control"
						type="number"
						id={nameMedian}
						name={nameMedian}
						onChange={(event) => this.handlePriceMedianInputUpdate(event, index)}
						value={leasingPriceMedian}
					/>
				)

				/*let leasingPercentSelect = (
					<select className="form-control"
									name={'leasingPercent_'+nameMedian}
									onChange={(event) => this.handlePercentInput(event, index)}
									value={leasingPricePercent}
					>
						{leasingPercents.map(leasingPercent => {
							if(leasingPercent.percent_value === leasingPricePercent){
								return (
									<option key={leasingPercent.percent_id}
													value={leasingPercent.percent_value}
													selected="selected"
									>
										{leasingPercent.percent_name}
									</option>
								)
							}else{
								return (
									<option key={leasingPercent.percent_id}
													value={leasingPercent.percent_value}
									>
										{leasingPercent.percent_name}
									</option>
								)
							}

						})}
					</select>
				)*/

				return (
					<tr key={index}>
						<td style={{width: 100}}>{nameMedian} | {leasing.car_leasing_id}</td>
						<td style={{width: 150}}>{inputM}</td>
						{/*<td style={{width: 150}}>{leasingPercentSelect}</td>
						<td style={{width: 150}}>{leasingPrice>0? NumberUtil.addCommas(leasingPrice) : '-'}</td>*/}
					</tr>
				)

			})

		}
		return (
			<div className="card card-accent-primary">
				<form action="" method="post" onSubmit={this.props.onSubmit}>
					<div className="card-header">
						<strong>บันทึกยอดจัด</strong>
					</div>
					<div className="card-block">
						<div className="row text-center">
							<table className="tableWhitesmoke" style={{marginTop: 8}}>
								<thead>
								<tr>
									<th className="text-center" >ลิสซิ่ง</th>
									<th className="text-center" >ราคากลาง</th>
									{/*<th className="text-center" >เปอร์เซนต์</th>*/}
									{/*<th className="text-center" >ยอดจัด</th>*/}
								</tr>
								</thead>
								<tbody>
								 {trLeasing}
								</tbody>
							</table>
						</div>
						<div className="row col-12 text-center">
							<button type="submit" className="btn btn-warning">แก้ไขยอดจัด</button>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

export default CarLeasingForm2;
